import { forwardRef, useImperativeHandle, useState } from 'react';
import { flushSync } from 'react-dom';
import type { Question, FormValue } from '../../types';
import { BespokeLayoutRenderer } from '../layout/BespokeLayoutRenderer';
import type { LayoutNode } from '../layout/types';

export type JsonReachabilityHarnessHandle = {
  replaceAnswers(next: Record<string, FormValue>): void;
};

export const JsonReachabilityHarness = forwardRef<
  JsonReachabilityHarnessHandle,
  { layout: LayoutNode[]; schema: Question[] }
>(function JsonReachabilityHarness({ layout, schema }, ref) {
  const [answers, setAnswersState] = useState<Record<string, FormValue>>({});
  useImperativeHandle(ref, () => ({
    replaceAnswers(next) {
      flushSync(() => setAnswersState(next));
    },
  }));

  return (
    <BespokeLayoutRenderer
      layout={layout}
      answers={answers}
      onAnswerChange={(qid, value) =>
        flushSync(() => setAnswersState(prev => ({ ...prev, [qid]: value })))
      }
      onFormDataChange={() => {}}
      schema={schema}
      schemaQuestionOptions={[]}
      sectionName='layout-json-studio'
    />
  );
});

JsonReachabilityHarness.displayName = 'JsonReachabilityHarness';
